import { gql, TypedDocumentNode } from '@apollo/client'

import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const GENERAL_FRAGMENT: TypedDocumentNode<AbTestsParametersSchemaDTO['general']> = gql`
  ${LABEL_FRAGMENT}

  fragment generalFragment on AbTestsParametersGeneral {
    advancedSettings {
      ...labelFragment
    }
    customCode {
      ...labelFragment
    }
    label
  }
`
